module.exports = __webpack_public_path__ + "templates/input-address.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/input-address/input-address.component.html
// module id = pLt1
// module chunks = 1